//don't add any newlines between the tick marks, otw you'll get a blank item in the bucket of texts
const letterText_es = `A
Á
B
C
D
E
É
F
G
H
I
Í
J
K
L
M
N
Ñ
O
Ó
P
Q
R
S
T
U
Ú
V
W
X
Y
Z`;
export default letterText_es;
